export default "/images/52636fe35cf7e966409588d0c5603004.avif";